import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React from "react";
import GetAppIcon from "@material-ui/icons/GetApp";
import IconButton from "@material-ui/core/IconButton";
import { formatDate } from "../../../common/formatDate";
import { useFetchContext } from "../../../common/FetchContext";
import { useStressEntryContext } from "./StressEntryContext";

export const StressFileList = () => {
  const { state } = useStressEntryContext();
  const { authAxios } = useFetchContext();

  const data = state.actionApiResponse ?? {};

  const runFiles = data.stress_run_files ?? [];

  const logFiles = data.log_run_files ?? [];

  // Download file
  const downloadFile = async (url: string, fileName: string) => {
    try {
      const response = await authAxios.get(url, {
        responseType: "blob",
      });

      const disposition = response.headers["content-disposition"];

      let downloadFileName = fileName || "download";

      if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match && match[1]) {
          downloadFileName = match[1];
        }
      }

      const blobUrl = window.URL.createObjectURL(response.data);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = downloadFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("File download failed:", error);
    }
  };

  // Reusable table
  const renderFileTable = (
    title: string,
    files: any[],
    emptyMessage: string,
  ) => (
    <Grid item xs={12}>
      <Typography variant="h6" style={{ margin: "16px 0 8px" }}>
        {title}
      </Typography>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Run Name</TableCell>
              <TableCell>File Name</TableCell>
              <TableCell>Uploaded By</TableCell>
              <TableCell>Uploaded Date</TableCell>
              <TableCell align="center">Download</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {files.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  {emptyMessage}
                </TableCell>
              </TableRow>
            ) : (
              files.map((file: any, index: number) => (
                <TableRow key={`${file.stress_file}-${index}`}>
                  <TableCell>{file.run_name?.trim() || "-"}</TableCell>
                  <TableCell>{file.filename || "-"}</TableCell>
                  <TableCell>{file.user || "-"}</TableCell>
                  <TableCell>
                    {file.run_date ? formatDate(file.run_date) : "-"}
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Download">
                      <IconButton
                        size="small"
                        onClick={() =>
                          downloadFile(
                            file.stress_download_url,
                            file.filename || file.run_name || "download",
                          )
                        }
                      >
                        <GetAppIcon color="primary" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );

  return (
    <Grid container spacing={2}>
      {renderFileTable("Run Files", runFiles, "No run files available")}

      {renderFileTable("Log Files", logFiles, "No log files available")}
    </Grid>
  );
};
